module.exports = __webpack_public_path__ + "static/Reza-2cb57be9c41ea090544cd3838f7d4bef.jpg";